import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { uniqueId } from 'lodash';
import { getScriptInitVariables } from '@/services/execScriptService';
import { clusterList } from '@/services/resourceService';
import { convertDetailToProps } from '@/pages/Maintenance/Template/Variables/components/VarInput';

const initialState = {
  isTemp: false, // 临时脚本
  currentTemplate: null, // 当前脚本
  cluster: null, // 选中的集群(包含envId)
  clusterOptions: [], // 集群列表
  template: null, // 当前选中的模板
  cmpVariables: [], // 组件变量
  ipVariables: [], // ip变量
  codeContent: '', // 脚本内容
  hosts: [], // 主机
  k8s: null, // k8s主机信息
};

// 获取脚本初始化变量
export const fetchScriptInitVariables = createAsyncThunk(
  'execScript/fetchScriptInitVariables',
  async (params) => {
    const response = await getScriptInitVariables(params);
    return response.data;
  },
);

// 获取集群列表
export const fetchClusterOptions = createAsyncThunk(
  'execScript/fetchClusterOptions',
  async (envId) => {
    const response = await clusterList({ envId, pageSize: 99999, startIndex: 1 });
    return response.data;
  },
);

export const execScriptSlice = createSlice({
  name: 'execScript',
  initialState,
  reducers: {
    setCluster: (state, action) => {
      const { clusterOptions } = state; // 保留，其他清空
      const clusterId = action.payload;
      return {
        ...initialState,
        clusterOptions,
        cluster: clusterOptions.find((item) => item.value === clusterId),
      };
    },
    // 点击temp
    toggleTemp: (state) => {
      state.isTemp = !state.isTemp;
    },

    setTemplate: (state, action) => {
      state.template = action.payload;
    },

    setCmpVariables: (state, action) => {
      state.cmpVariables = action.payload;
    },
    setIpVariables: (state, action) => {
      state.ipVariables = action.payload;
    },

    setCodeContent: (state, action) => {
      state.codeContent = action.payload || '';
    },
    modifyHosts: (state, action) => {
      state.hosts = action.payload;
    },
    removeHost: (state, action) => {
      state.hosts = state.hosts.filter((item) => item.id !== action.payload);
    },
    resetScript: () => {
      return initialState;
    },
    setK8sClient: (state, action) => {
      state.k8s = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScriptInitVariables.fulfilled, (state, action) => {
        const { scriptStencilVariableDetailVOList } = action.payload;
        const { hosts } = state;

        const variables = (scriptStencilVariableDetailVOList || []).map((item) => {
          // 标记选中;
          const tagSelect = item.variableType === 0 || item.notEqual;
          return {
            ...item,
            keyName: item.label, // label转换
            inputProps: convertDetailToProps(item.showDetail),
            host: hosts.find((host) => host.id === item.hostId),
            id: uniqueId(), // 重新生成唯一id
            tagSelect,
            canDelete: !tagSelect, // 是否允许手动删除
            originId: item.id, // 保留原来id
            originValue: item.defaultValue, // 备份默认值，方便删除时恢复,拿最新
          };
        });
        // 组件包级别;
        state.cmpVariables = variables.filter((item) => item.variableLevel === 0);

        // ip级别;
        state.ipVariables = variables.filter((item) => item.variableLevel === 1);
      })
      .addCase(fetchClusterOptions.pending, (state) => {
        state.clusterOptions = [];
      })
      .addCase(fetchClusterOptions.fulfilled, (state, action) => {
        const { items } = action.payload;
        return {
          ...initialState,
          clusterOptions: items.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          })),
        };
      });
  },
});

export const {
  setCluster,
  toggleTemp,
  setTemplate,
  setCmpVariables,
  setIpVariables,
  setCodeContent,
  modifyHosts,
  removeHost,
  resetScript,
  setK8sClient,
} = execScriptSlice.actions;
export default execScriptSlice.reducer;
